import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function MainLayout() {
  return (
    <div className="hcf-mainLayout__container">
      <Header />
      <main className="hcf-mainLayout__content">
        <Outlet />
      </main>
      <div className="hcf-mainLayout__footer">
        <Footer />
      </div>
    </div>
  );
}
